import React from 'react';
import CardBaseInput from './CardBaseInput';

class CardZipInput extends CardBaseInput {
  constructor(props) {
    super(props);
    this.handleChangeZip = this.handleChangeZip.bind(this);
    this.handleKeyPressZip = this.handleKeyPressZip.bind(this);
  }

  handleChangeZip(props = {}) {
    return e => {
      const zip = e.target.value || '';
      this.setInputTouched(false);

      const { onChange = () => {} } = props;
      onChange && onChange(zip);
    };
  }

  handleKeyPressZip(props = {}) {
    return e => {
      const zip = e.target.value || '';

      const { onKeyPress = () => {} } = props;
      onKeyPress && onKeyPress(zip);
    };
  }

  render() {
    const props = {
      'aria-label': 'Zip',
      autoComplete: 'shipping postal-code',
      id: 'zip',
      name: 'zip',
      placeholder: 'Zip Code',
      type: 'text',
      ...this.props,
      onBlur: this.handleBlurInput(this.props),
      onChange: this.handleChangeZip(this.props),
      onKeyPress: this.handleKeyPressZip(this.props),
    };

    const { touched, error } = this.state;

    return (
      <div className="input-area">
        <input {...props} />
        <div className="error-view">{touched && error}</div>
      </div>
    );
  }
}

export default CardZipInput;
